import React, { memo, useContext } from "react";

import {
  Box,
  IconButton,
  InputAdornment,
  TableCell,
  TableRow,
  TextField,
  Tooltip,
} from "@mui/material";

import { useState } from "react";
import { withRouter } from "react-router";
import ButtonsAction from "../../../components/Tablas/ButtonsAction";
import AuthContext from "../../../../Context/Auth/AuthContext";
import { Cancel, Check, Map } from "@mui/icons-material";

import { trimPropsItem } from "../../../../config/const";
import {
  useRowStyles,
  butonIconTransition,
} from "../../../../styles/stylesRows";
import DialogMap from "../../../components/Dialogs/DialogMap";

const Row = (props) => {
  // CLASES
  const classes = useRowStyles();
  // PROPS
  const { setopen, socket } = props;

  // CONTEXT
  const { usuario } = useContext(AuthContext);
  // COPIA DEL REGISTRO PARA EDITAR
  const objectDefault = {
    id: "",
    ubicacion: "",
    puesto: "",
    coordenadas: {
      latitud: -0.239079,
      longitud: -79.171853,
    },
    usuario: "admin",
    cod_empresa: "ZARACAY",
    // fecReg: "2025-04-10T16:59:22.000Z",
    // fecUpd: "2025-04-10T22:03:03.000Z",
    // tabla: "ubicacion_trabajo",
    // rucempresa: "ZARACAY",
    // rol: [],
  };
  const [item, setitem] = useState(objectDefault);
  const [openMap, setopenMap] = useState(false);
  //onChange
  const handleChange = (e) => {
    setitem({ ...item, [e.target.name]: e.target.value });
  };
  // DESHABILITAR BOTON
  const botonDisabled = () => {
    if (item.ubicacion.trim() === "" || item.puesto.trim() === "") {
      return true;
    }
  };
  // ELIMINAR EL REGISTRO
  const funcSubmit = () => {
    try {
      console.log(
        trimPropsItem({
          ...item,
          tabla: "ubicacion_trabajo",
          usuario: usuario.usuario,
          cod_empresa: usuario.rucempresa,
          // fecReg: "2025-04-10T16:59:22.000Z",
          // fecUpd: "2025-04-10T22:03:03.000Z",
          tabla: "ubicacion_trabajo",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
        })
      );

      socket.current.emit(
        "client:guardarData",
        trimPropsItem({
          ...item,
          tabla: "ubicacion_trabajo",
          usuario: usuario.usuario,
          cod_empresa: usuario.rucempresa,
          // fecReg: "2025-04-10T16:59:22.000Z",
          // fecUpd: "2025-04-10T22:03:03.000Z",
          tabla: "ubicacion_trabajo",
          rucempresa: usuario.rucempresa,
          rol: usuario.rol,
        })
      );
      setitem(objectDefault);
      setopen(false);
    } catch (error) {
      console.log({ error });
    }
  };

  return (
    <React.Fragment>
      <TableRow className={classes.root} component={"form"}>
        {/* boton */}
        <TableCell
          size="small"
          align="center"
          className={classes.celda}
        ></TableCell>
        <ButtonsAction
          botones={[
            {
              tooltip: "Cancelar",
              texto: "",
              funcion: () => {
                setopen(false);
                setitem(objectDefault);
                // setItemEdit(itemHijo);
              },
              disabled: false,
              Icon: Cancel,
              color: "error",
              id: 1,
              ocultar: false,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
            },
            {
              tooltip: "Guardar",
              texto: "",
              funcion: () => {
                funcSubmit();
              },
              disabled: botonDisabled(),
              Icon: Check,
              color: "success",
              id: 2,
              ocultar: false,
              tipo: "icono",
              variante: "contained",
              size: "small",
              sx: butonIconTransition,
              submit: true,
            },
          ]}
        />
        <>
          <DialogMap
            open={openMap}
            setopen={setopenMap}
            setitem={setitem}
            item={item}
            editar={false}
            propiedad={item.coordenadas}
            nombrePropiedad={"coordenadas"}
            solover={false}
          />
          <TableCell size="small" align="center" className={classes.celda}>
            <TextField
              value={item.ubicacion}
              name="ubicacion"
              onChange={(e) => handleChange(e)}
              size="small"
              fullWidth
            />
          </TableCell>
          <TableCell size="small" align="center" className={classes.celda}>
            <TextField
              value={item.puesto}
              name="puesto"
              onChange={(e) => handleChange(e)}
              size="small"
              fullWidth
            />
          </TableCell>{" "}
          <TableCell size="small" align="center" className={classes.celda}>
            <TextField
              disabled
              value={item.coordenadas.latitud + " " + item.coordenadas.longitud}
              size="small"
              fullWidth
              InputProps={{
                endAdornment: (
                  <Box htmlFor="contained-button-documento" fullWidth>
                    <InputAdornment>
                      <Tooltip title="Mostrar Mapa" arrow>
                        <Box>
                          <IconButton
                            aria-label=""
                            onClick={() => setopenMap(true)}
                          >
                            <Map color="secondary" />
                          </IconButton>
                        </Box>
                      </Tooltip>
                    </InputAdornment>
                  </Box>
                ),
              }}
            />
          </TableCell>
          <TableCell size="small" align="center" className={classes.celda}>
            -
          </TableCell>
          <TableCell
            size="small"
            align="center"
            className={classes.celda}
          ></TableCell>
          <TableCell size="small" align="center" className={classes.celda}>
            -
          </TableCell>
        </>
      </TableRow>
    </React.Fragment>
  );
};

export default withRouter(memo(Row));
